import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";

function CardCarouselReviewPage() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      if (Array.isArray(response?.data) && response?.data.length > 0) {
        setReviewsData(response.data);
      } else {
        setReviewsData([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  const renderStars = (rating) => {
    const stars = [];
    const starCount = rating || 5;
    for (let i = 0; i < starCount; i++) {
      stars.push(
        <li key={i}>
          <i className="fa fa-star"></i>
        </li>
      );
    }
    return stars;
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Reviews" Image="theme-2-banner-review.webp"/>

        <div className="container">
          <h2 className="my-5 text-center">
            {isLoading
              ? ""
              : reviewsData?.length === 0
                ? "No Record Available"
                : "WHAT PATIENTS ARE SAYING"}
          </h2>

          <div className="row testimonails" data-animation="fadeInRight">
            {isLoading ? (
              <div className="d-flex align-items-center justify-content-center w-100">
                <Spinner />
              </div>
            ) : reviewsData?.length === 0 ? (
              <div className="d-flex align-items-center justify-content-center w-100"></div>
            ) : (
              reviewsData.map((data, index) => (
                <div
                  key={index}
                  className="col-lg-6 testimonial-style-5 dark-switch item mb-5"
                >
                  <div className="testimonial-style-2" style={{ height: "270px" }}>
                    <div className="testimonial-inner">
                      <div className="testimonial-details text-left">

                        <div
                          className="testimonial-description margin-top-15"
                          style={{
                            minHeight: "115px", // desktop ke liye
                            display: "flex",
                            alignItems: "flex-start"
                          }}
                        >
                          <p className="mb-4 pb-1 desription-card-carousal-reviews">
                            {data?.detail?.slice(0, window.innerWidth < 768 ? 70 : 150)}
                            {data?.detail?.length > (window.innerWidth < 768 ? 70 : 150) && (
                              <>
                                ...{" "}
                                <span
                                  onClick={() => handleShowMore(data)} 
                                  className="fw-bold"
                                  style={{ color: "#000", cursor: "pointer" }}
                                >
                                  See More
                                </span>
                              </>
                            )}
                          </p>

                        </div>
                        <div className="client-details text-left left-align d-flex align-items-center">
                          <div className="client-image">
                            <img
                              className="img-circle"
                              src={
                                data?.profile_image ||
                                "/assets/img/no-image.png"
                              }
                              style={{ width: "65px", height: "65px" }}
                              width="65"
                              height="65"
                              alt={data?.full_name}
                            />
                          </div>
                          <div className="client-info ms-3">
                            <h4 className="mb-1">{data?.full_name}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Review Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedReview && (
              <>
                <p>{selectedReview?.detail}</p>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="btn btn-default" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default CardCarouselReviewPage;
